// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#EF6266', // プライマリーカラー
    },
    secondary: {
      main: '#9083B8', // セカンダリーカラー
    },
    background: {
      default: '#EEE5DA', 
    },
    card: {
      default: '#FBF8F5'
    },
    text: {
      primary: '#72574E',
      secondary: '#83746F',
    },
    groom: {
      main: '#557697'
    },
    bride: {
      main: '#DC729D'
    },
    undefined: {
      main: '#9E9E9E'
    }
  },
  typography: {
    fontFamily: 'Lato, sans-serif',
    fontSize: 14,
  },
});

export default theme;

